/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Sorting type of the ports
 */
export type SortingType = (typeof SortingType)[keyof typeof SortingType];

export const SortingType = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;
